"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLET_PORTRAIT = exports.GUARANTEE_SECTION = exports.FEATURES_SECTION = void 0;
var FEATURES_SECTION = 600;
exports.FEATURES_SECTION = FEATURES_SECTION;
var GUARANTEE_SECTION = 750;
exports.GUARANTEE_SECTION = GUARANTEE_SECTION;
var TABLET_PORTRAIT = 800;
exports.TABLET_PORTRAIT = TABLET_PORTRAIT;


//////////////////
// WEBPACK FOOTER
// ./js/constants/Breakpoints.js
// module id = 195
// module chunks = 5 6